import React from "react";
import { BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF, FaGithub } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
          target="_blank"
          href={"https://www.linkedin.com/in/pankaj-kumar-yadav-0b5aa1182/"}
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
          target="_blank"
          href={"https://x.com/pankaj_time_"}
        >
          <BsTwitter />
        </a>
      </div>
     
      <div>
        <a
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
          target="_blank"
          href={"https://github.com/pankajtime123"}
        >
          <FaGithub />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
